// extracted by mini-css-extract-plugin
export default {"errorContainer":"Error_errorContainer__OLAHN","errorContent":"Error_errorContent__7c858","errorIcon":"Error_errorIcon__vxO74"};